module.exports = {"meta":{"lead":"Le laboratoire de Framasoft"}};